export const convertBytesToMegabytes = (bytes: number) => {
  return bytes / 1024 / 1024;
};
